import { Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogEditEventArgs, EditSettingsModel, ExcelExportProperties, GridColumnModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { Query } from '@syncfusion/ej2-data';
import { ValidationRules } from 'projects/sales/src/app/shared/models/app.model';
import { AlertMessages } from 'projects/sales/src/app/shared/constants/app.constants';
import { gridActionsForFiltering, updateFilterIcon } from 'projects/shared/src/lib/utils/grid-functions';
import { SharedService } from 'projects/shared/src/lib/shared.service';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-other-vacations-popup',
    templateUrl: './other-vacations-popup.component.html',
    styleUrls: ['./other-vacations-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtherVacationsPopupComponent implements OnInit {
  isMaximized: boolean = true;
  canEdit: boolean = false;
  gridName: string = 'other-vacations-grid';

  @ViewChild('columnChooser') columnChooser: any;
  categoryField: any;
  categoryObject: any;
  categoryDDL: any = [
    {
      text: 'Conference',
      value: 'Conference'
    },
    {
      text: 'Business Trip',
      value: 'Business Trip'
    },
    {
      text: 'Attending Trade Show',
      value: 'Attending Trade Show'
    },
    {
      text: 'Attending Training Event',
      value: 'Attending Training Event'
    },
    {
      text: 'Traveling',
      value: 'Traveling'
    },
    {
      text: 'Working Elsewhere',
      value: 'Working Elsewhere'
    },
    {
      text: 'Jury Duty',
      value: 'Jury Duty'
    },
    {
      text: 'Other',
      value: 'Other'
    }];

  public editSettings: EditSettingsModel;
  public dropdownParams: Object = {
    params: {
      dataSource: this.categoryDDL,
      fields: { text: 'value', value: 'value' },
      popupHeight: '200px',
    },
  };

  otherVacationsGrid!: GridComponent;
  otherVacationGridColumns!: GridColumnModel[];
  aggreagtes: any;
  count: number = 100;
  originalStateOtherDaysArray: any[] = [];
  hasUnsavedChanges: boolean = false;




  @ViewChild('otherVacationsGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.otherVacationsGrid = gridComponent;
      this.otherVacationsGrid.toolbar = this.setToolbar();
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OtherVacationsPopupComponent>,
    private sharedService: SharedService,) {
    this.editSettings = {
      allowAdding: true,
      allowEditing: true,
      allowDeleting: true,
      allowNextRowEdit: true,
      mode: 'Normal',
      newRowPosition: 'Bottom'
    };
  }

  ngOnInit() {
    this.canEdit = this.data?.mode === 'canEdit';
    this.originalStateOtherDaysArray = JSON.parse(JSON.stringify(this.data?.popupData?.other));
    this.data.popupData.other = this.data?.popupData?.other ?? [];
    this.data.popupData.other = this.data.popupData.other.map((item, index) => ({
      ...item,
      uId: index + 1
    }));
    this.otherVacationGridColumns = this.getOtherVacationsGridColumns();
    this.aggreagtes = [{
      columns: [
        {
          type: 'Sum',
          field: 'days',
          format: 'N',
          footerTemplate: 'Total duration: ${Sum}'
        }
      ]
    }];
  }
  getTotalOtherVacationDays(): number {
   return (this.data?.popupData?.other ?? []).reduce((total: number, row: any) => {
      return total + Number(row?.days || 0);
    }, 0);
  }
  actionBegin(args: any) {
    if (args.requestType == 'add') {
      // this.count = this.data.popupData.other.length > 0 && Math.max(...this.data.popupData.other?.map(item => item?.vrfId));
      args.data.uId = args?.data?.vrfId ?? Math.round(Math.random() * 100000);
      args.data.vrfId = args?.data?.vrfId ?? ++this.count;
      args.data.category = "Other";
      args.data.days = 1;
      args.data.id = this.count;

    } else if (args.requestType == 'save') {
      // A saved new row is inserted at index 0 unless told otherwise; keep it last, where it was typed.
      if (args.action == 'add') {
        args.index = this.data.popupData.other.length;
      }
      const currentValue = args?.data?.days;
      if(currentValue == 0 || !currentValue ) {
        this.sharedService.showNotification("info", "Value cant be 0 or null!");
        args.data.days = 1;
        return;
      }
      const sum = (this.data.popupData.other as any[]).reduce((accumulator, data) => accumulator + data.days, 0) + currentValue;
        if (sum > 365) {
          this.sharedService.showNotification("info","You cannot add other vacations accumulatively more than 365!");
          args.cancel = true;
          return;
        }
      this.otherVacationsGrid.refresh();
      this.hasUnsavedChanges = true;
      this.otherVacationsGrid.aggregateModule.refresh(this.otherVacationsGrid.getColumns());
    } else if (args.requestType == 'delete') {
      args.cancel = true;
    }
  }
  actionComplete(args: DialogEditEventArgs) {
    gridActionsForFiltering(args, this.otherVacationsGrid);
    updateFilterIcon(args, this.otherVacationsGrid);
  }
  setToolbar() {
    let toolbar = [
      { text: 'ColumnChooser', tooltipText: 'Show/Hide Columns', prefixIcon: 'fas fa-cogs', align: 'Left' }
    ] as any;

    const addIconIndex = toolbar?.findIndex((item: any) => item.id === 'column-chooser');
    if (this.canEdit) {
      toolbar.push('Add');
    }

    return toolbar;
  }
  commandClick(args: any) {
    let rowData = args?.rowData;
    if (args?.commandColumn.type == 'Delete') {
      this.sharedService.showConfirmation(`Are you sure to delete ${rowData?.days} days of vacation${rowData?.category ? ': '+rowData?.category : ''}?`)
      .then((res: any) => {
        if (res?.isConfirmed) {
          const i = this.data.popupData.other.findIndex((d: any) => d.uId == rowData?.uId);
          this.data.popupData.other.splice(i, 1);
          this.hasUnsavedChanges = true;
          this.otherVacationsGrid.refresh();
        }
      });
    }
  }
  onContactsGridCreated(args: any) {
    updateFilterIcon({ requestType: 'filtering' }, this.otherVacationsGrid);
    this.otherVacationsGrid.editSettings.allowEditing = this.canEdit;
    this.otherVacationsGrid.editSettings.allowAdding = this.canEdit;
    this.otherVacationsGrid.editSettings.allowDeleting = this.canEdit;
    this.otherVacationsGrid.editSettings.allowNextRowEdit = this.canEdit;
  }
  onRowDataBound(args: any) {
    const $row = args.row;
    if (this.canEdit) {
      $row?.getElementsByClassName('delete-button')[0]?.classList.remove('disabled');
    } else {
      $row?.getElementsByClassName('delete-button')[0]?.classList.add('disabled');
    }
  }
  getOtherVacationsGridColumns() {
    let columns: GridColumnModel[] = [
      { field: "id", showInColumnChooser: false, visible: false, width: 20 },
      { field: "vrfId", showInColumnChooser: false, visible: false, width: 20 },
      { field: "category", headerText: "Category", width: 40, edit: this.initCategory(), filter: { type: 'Excel' } },
      { field: "days", headerText: "Duration", validationRules: { required: ValidationRules.field.required }, type: 'number', format: 'n', allowEditing: true, allowSorting: true, allowResizing: true, textAlign: 'Left', width: 25, visible: true  },
      { field: 'Actions', headerText: 'Actions', width: 20, showInColumnChooser: false, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false, clipMode: 'Clip',
        commands: [
          {
            type: 'Delete',
            buttonOption: { cssClass: 'e-flat delete-button', iconCss: 'fas fa-trash' },
          }
        ]
      }
    ];
    return columns;
  }
  onCategoryChange(e: any, args: any) {
    if(e?.isInteracted) {
      this.hasUnsavedChanges = true;
      const rowData = args?.rowData;
      const i = this.data.popupData.other.findIndex((d: any) => d.uId == rowData?.uId);
      if(i > -1) {
        this.data.popupData.other[i].category = rowData.category;
        this.data.popupData.other[i].days = rowData.days;
      }
    }
  }
  close(add?: boolean) {
    this.otherVacationsGrid.isEdit && this.otherVacationsGrid.endEdit();
    const hasInvalidDays: boolean = this.data.popupData.other.some(
      (row: any) => !row?.days || row?.days <= 0
    );
    if (add && hasInvalidDays) {
      this.sharedService.showNotification(
        "info",
        "Cannot add a record with zero or empty days!"
      );
      return;
    }
    const totalDays = this.getTotalOtherVacationDays();
    if (add && totalDays > 365) {
      this.sharedService.showNotification(
        "info",
        "Total duration cannot be greater than 365 days!"
      );
      return;
    }
    if (!add && this.hasUnsavedChanges) {
      if (hasInvalidDays) {
        this.sharedService.showNotification("info", "Cannot add a record with zero days!");
      } else {
        this.sharedService.showConfirmation(AlertMessages.unsavedChangesLost).then((res) => {
          if (res?.isConfirmed) {
            this.data.popupData.other = this.originalStateOtherDaysArray;
            this.returnOthers(false);
          }
        });
      }
    } else {
      this.returnOthers(this.hasUnsavedChanges);
    }
  }

  returnOthers(opt: boolean) {
    this.data.popupData.other = this.data.popupData.other.map((d: any) => {
      d?.id > 99 ? d.id = 0 : null;
      d.category = (d?.category ?? 'Other' as string).trim();
      d?.vrfId > 99 ? d.vrfId = null : null;
      return d;
    })
    this.dialogRef.close({isInteracted: this.hasUnsavedChanges, result: this.data.popupData.other});
  }
  onDaysChange(val: any, data: any) {
    if(val) {
      this.otherVacationsGrid.dataSource[data?.index].days = Math.round(val);
      this.otherVacationsGrid.isEdit && this.otherVacationsGrid.endEdit();
      this.otherVacationsGrid.aggregateModule.refresh(this.otherVacationsGrid.getColumns());
    }
  }

  initCategory() {
      return {
        create: () => {
          this.categoryField = document.createElement('input');
          return this.categoryField;
        },
        read: () => {
          return this.categoryObject ? (this.categoryObject.itemData?.text || this.categoryObject.text || this.categoryObject.value || '') : '';
        },
        destroy: () => {
          this.categoryObject?.destroy();
        },
        write: (args: any) => {
          this.categoryObject = new DropDownList({
            dataSource: this.categoryDDL,
            fields: { text: 'text', value: 'value' },
            enabled: this.canEdit,
            value: args.rowData.category,
            change: (e: any) => {
              args.rowData.category = e?.value;
              this.onCategoryChange(e, args);
            }
          });
          this.categoryObject.appendTo(this.categoryField);
        }
      };
    }
}
